"use client"

import { useState } from "react"
import { Collapse, Row, Col, Card, Dropdown, Button, Space } from "antd"
import {
  DownOutlined,
  EditOutlined,
  DeleteOutlined,
  ShareAltOutlined,
  CopyOutlined,
  EyeOutlined,
  DownloadOutlined,
} from "@ant-design/icons"
import MainLayout from "../../../../components/layouts/enhancement/MainLayout"
import TopContent from "../../../../components/layouts/enhancement/TopContent"
import { labelConfig, staticConfig } from "../../operations.config";
import {  useNavigate } from "react-router-dom"
import "../../../../assets/styles/InterbankPlacement.css";


const { Panel } = Collapse

const DetailInterbankPlacement = () => {
  const navigate = useNavigate()
  const [activeKeys, setActiveKeys] = useState(["1", "2"])
  const [open, setOpen] = useState(false)

  const handleCollapseChange = (keys) => {
    setActiveKeys(keys)
  }

  const handleMenuClick = (e) => {
    console.log("Clicked on menu item:", e.key)
    setOpen(false)
  }

  const items = [
    {
      key: "1",
      label: (
        <Space>
          <EditOutlined />
          Edit
        </Space>
      ),
    },
    {
      key: "2",
      label: (
        <Space>
          <DeleteOutlined />
          Delete
        </Space>
      ),
      danger: true,
    },
    {
      key: "3",
      label: (
        <Space>
          <ShareAltOutlined />
          Share
        </Space>
      ),
    },
    {
      key: "4",
      label: (
        <Space>
          <CopyOutlined />
          Duplicate
        </Space>
      ),
    },
    {
      key: "5",
      label: (
        <Space>
          <EyeOutlined />
          View Details
        </Space>
      ),
    },
    {
      key: "6",
      label: (
        <Space>
          <DownloadOutlined />
          Download
        </Space>
      ),
    },
  ]

  const handleOpenChange = (flag) => {
    setOpen(flag)
  }

  const handleGoBack=()=>{
    navigate("/new-operations-interbank-placement")
  }
  // Custom expand icon that rotates when panel is expanded
  const customExpandIcon = ({ isActive }) => (
    <DownOutlined
      rotate={isActive ? 180 : 0}
      style={{
        fontSize: "12px",
        color: "#666",
        transition: "all 0.3s",
      }}
    />
  )

  // Styled label-value row component with different background colors
  const InfoRow = ({ label, value, highlight }) => (
    <Row style={{ borderBottom: "1px solid #f0f0f0" }}>
      <Col
        span={12}
        style={{
          color: "#666",
          backgroundColor: "#F9FAFB",
          padding: "12px 16px",
          borderRight: "1px solid #f0f0f0",
        }}
      >
        {label}
      </Col>
      <Col
        span={12}
        style={{
          backgroundColor: "#FFFFFF",
          padding: "12px 16px",
        }}
      >
        {highlight ? (
          <span
            style={{
              backgroundColor: "#f9f0ff",
              color: "#b026ff",
              padding: "2px 8px",
              borderRadius: "20px",
              fontSize: "14px",
            }}
          >
            {value}
          </span>
        ) : (
          <span>{value}</span>
        )}
      </Col>
    </Row>
  )

  return (
    <MainLayout
      pageItems={staticConfig.moneyMarketInterbankPlacementBreadcrumbItems}
    >
      <TopContent
       pageTitle={labelConfig.manageMoneyMarketInterbankPlacement}
        createPageTitle={labelConfig.detailMoneyMarketInterbankPlacement}
      />
      
      <Card className="body-card">
        <h2 style={{ fontSize: "24px", fontWeight: "600", marginBottom: "4px" }}>Preview</h2>
        <p style={{ color: "#666", marginBottom: "24px" }}>
          Confirm the details of your Treasury Bill investment before publishing
        </p>

        <Collapse
          activeKey={activeKeys}
          onChange={handleCollapseChange}
          expandIcon={customExpandIcon}
          bordered={false}
          style={{
            background: "#fff",
            marginBottom: "16px",
          }}
        >
          <Panel header={<span style={{ fontWeight: "500", fontSize: "16px" }}>Deal Overview</span>} key="1">
            <div
              style={{
                border: "1px solid #f0f0f0",
                marginBottom: "16px",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <InfoRow label="Deal Reference" value="FB2039N" />
              <InfoRow label="Deal Date" value="MATTHEW OLA OLA" />
              <InfoRow label="Deal Amount" value="Customer" highlight={true} />
              <InfoRow label="Value Date" value="Retail" highlight={true} />
              <InfoRow label="Maturity Date" value="Savings Account" highlight={true} />
              <InfoRow label="Interest Rate" value="US Dollars" highlight={true} />
              <InfoRow label="Interest Calculation Basis" value="$ 4,508,808,834.09" />
            </div>
          </Panel>

          <Panel header={<span style={{ fontWeight: "500", fontSize: "16px" }}>Counterparty Details</span>} key="2"          
            style={{
              marginBottom: "16px",
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              overflow: "hidden"}}
          >
            <div
              style={{
                border: "1px solid #f0f0f0",
                marginBottom: "16px",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <InfoRow label="Bank Name" value="FB2039N" />
              <InfoRow label="SWIFT/BIC Code" value="MATTHEW OLA OLA" />
              <InfoRow label="Country" value="Customer" highlight={true} />
              <InfoRow label="City" value="Retail" highlight={true} />
              <InfoRow label="Street" value="Savings Account" highlight={true} />
              <InfoRow label="Risk Rating" value="US Dollars" highlight={true} />
              <InfoRow label="Exposure Limit" value="$ 4,508,808,834.09" />
              <InfoRow label="Current Exposure" value="Tuesday, March 21, 2025" />
              <InfoRow label="Limit Expiry" value="Tuesday, March 21, 2025" />

              <div
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                  padding: "12px 16px",
                  borderTop: "1px solid #f0f0f0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                Dealing Officer
              </div>

              <InfoRow label="Full Name" value="FB2039N" />
              <InfoRow label="Email" value="MATTHEW OLA OLA" />
              <InfoRow label="Phone" value="Customer" highlight={true} />
              <InfoRow label="Dealing Room Phone" value="Retail" highlight={true} />
            </div>
          </Panel>

          <Panel header={<span style={{ fontWeight: "500", fontSize: "16px" }}>Settlement Instruction</span>} key="3">
            <div
              style={{
                border: "1px solid #f0f0f0",
                marginBottom: "16px",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <InfoRow label="Settlement Bank Name" value="FB2039N" />
              <InfoRow label="Account Number" value="MATTHEW OLA OLA" />
              <InfoRow label="Account Name" value="Customer" highlight={true} />
              <InfoRow label="Currency" value="Retail" highlight={true} />
              <InfoRow label="Value Date" value="Savings Account" highlight={true} />
              <InfoRow label="Uploaded Agreement" value="US Dollars" highlight={true} />
            </div>
          </Panel>
        </Collapse>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "16px", marginTop: "40px" }}>
          <Button
            style={{
              borderRadius: "4px",
              padding: "0 20px",
              height: "40px",
            }}
            onClick={()=>handleGoBack()}
          >
            Go back
          </Button>
          <Button
            type="primary"
            style={{
              backgroundColor: "#b026ff",
              borderColor: "#b026ff",
              borderRadius: "4px",
              padding: "0 20px",
              height: "40px",
            }}
          >
            Submit
          </Button>
        </div>
      </Card>
    </MainLayout>
  )
}

export default DetailInterbankPlacement
